<mdb-navbar SideClass="navbar fixed-top navbar-expand-md navbar-dark mdb-color darken-3 scrolling-navbar ie-nav"
            [containerInside]="false">
  <logo>
    <a class="logo navbar-brand waves-light" [routerLink]="['']">
      <img src="assets/images/logo.png" alt="Logo" height="40" width="40">
    </a>
  </logo>
  <logo>
    <a class="logo navbar-brand waves-light" href="http://cbml.ds.unipi.gr/" target="_blank">
      <img class="labLogo" src="assets/images/header.png" alt="Logo">
    </a>
  </logo>
  <links>
    <ul class="navbar-nav mr-auto">
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['home']">
          <i class="fa fa-smile"></i> Face Analysis
        </a>
      </li>
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['face-api/face']">
          <i class="fa fa-smile-wink"></i> Face Analysis 2
        </a>
      </li>
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['object-detection']">
          <i class="fa fa-video"></i> Object Detection
        </a>
      </li>
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['speech']">
          <i class="fa fa-comment"></i> Speech Analysis
        </a>
      </li>
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['semantics']">
          <i class="fa fa-link"></i> Semantic Analysis
        </a>
      </li>
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['speech-to-text']">
          <i class="fa fa-comment-dots"></i> Speech to Text
        </a>
      </li>
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['about']">
          <i class="fa fa-info"></i> About
        </a>
      </li>
      <li class="nav-item waves-light" [routerLinkActive]="['active']">
        <a class="nav-link" mdbRippleRadius [routerLink]="['help']">
          <i class="fa fa-question"></i> Help
        </a>
      </li>
    </ul>
    <span class="float-right">
         <ul class="navbar-nav mr-auto">
           <li class="nav-item waves-light" [routerLinkActive]="['active']">
              <a class="nav-link" mdbRippleRadius (click)="commonService.switchViewMode()">
                           <img *ngIf="commonService.getViewMode()" class="userIcon"
                                src="assets/images/switches/switch-on.svg"/>
                           <img *ngIf="!commonService.getViewMode()" class="userIcon"
                                src="assets/images/switches/switch-off.svg"/>
              </a>
            </li>
         </ul>
      </span>
  </links>
</mdb-navbar>
